"use strict";
import React from "react";
import { useMismatchContext } from "features/smartWallet/mismatch/MismatchContext";
import {
  useCurrentAccountChainMismatchEffect,
  useOnConnectCheckAllAccountChainMismatchEffect
} from "features/smartWallet/mismatch/hooks";
import { useOnDisconnectEffect } from "features/smartWallet/mismatch/useOnDisconnectEffect";
import { isTestEnv } from "utilities/src/environment/env";
const MismatchAccountEffectsInner = React.memo(() => {
  useOnConnectCheckAllAccountChainMismatchEffect();
  useCurrentAccountChainMismatchEffect();
  return null;
});
MismatchAccountEffectsInner.displayName = "MismatchAccountEffects";
export const MismatchAccountEffects = () => {
  const account = useMismatchContext().account;
  useOnDisconnectEffect();
  if (!account.address || isTestEnv()) {
    return null;
  }
  return <MismatchAccountEffectsInner />;
};
